// removed by extract-text-webpack-plugin
module.exports = {"view-message":"view-message","view-message-wrapper":"view-message-wrapper","view-message-header":"view-message-header","card-wrapper":"card-wrapper","sender-wrapper":"sender-wrapper","message-actions":"message-actions","attachment-divider":"attachment-divider","ant-upload-list-item-info":"ant-upload-list-item-info"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ViewMessages/ViewMessages.scss
// module id = 5116
// module chunks = 1